var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "fixed inset-0 z-50" },
    [
      _c(
        "SiteMenuFlyoutLayout",
        {
          attrs: { heading: _vm.heading },
          on: {
            close: function ($event) {
              return _vm.$emit("close")
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "space-y-4" },
            _vm._l(_vm.combinedMenus, function (menu, menuKey) {
              return _c(
                "button",
                {
                  key: menuKey,
                  staticClass:
                    "w-full bg-white rounded-lg p-7 relative z-10 overflow-hidden text-left focus:outline-none",
                  style: {
                    backgroundColor: _vm.menuThemes[menuKey][0],
                    color: _vm.menuThemes[menuKey][1],
                  },
                  on: {
                    click: function ($event) {
                      return _vm.openMenu(menuKey)
                    },
                  },
                },
                [
                  _c("div", { staticClass: "w-60 max-w-full space-y-5" }, [
                    _c("h4", { staticClass: "text-lg font-semibold" }, [
                      _vm._v(_vm._s(menu.heading)),
                    ]),
                    _vm._v(" "),
                    menu.description
                      ? _c("p", { staticClass: "text-sm" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(menu.description) +
                              "\n          "
                          ),
                        ])
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  menu.backgroundImage.length
                    ? _c("InlineSvg", {
                        staticClass:
                          "w-full h-auto absolute left-0 top-0 -z-10",
                        attrs: {
                          src: menu.backgroundImage[0].url,
                          "transform-source": _vm.removeSvgFill,
                          fill: menu.backgroundImageColour,
                        },
                      })
                    : _vm._e(),
                ],
                1
              )
            }),
            0
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "fade" } },
        [
          _vm.isOpenedMenu(_vm.PRIMARY_KEY)
            ? _c("SiteMenuFlyoutMegaPrimary", {
                attrs: {
                  theme: _vm.menuThemes[_vm.PRIMARY_KEY],
                  heading: _vm.primaryMenu.heading,
                  items: _vm.primaryMenu.items,
                },
                on: { close: _vm.closeMenu },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "fade" } },
        [
          _vm.isOpenedMenu(_vm.SECONDARY_KEY)
            ? _c("SiteMenuFlyoutMegaSecondary", {
                attrs: {
                  theme: _vm.menuThemes[_vm.SECONDARY_KEY],
                  heading: _vm.secondaryMenu.heading,
                  items: _vm.secondaryMenu.items,
                  "background-image-colour":
                    _vm.secondaryMenu.backgroundImageColour,
                },
                on: { close: _vm.closeMenu },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }